import { useContext } from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
// Our Components
import { CardContext } from 'context/cards/cardContext';
import { CLOSE_NO_BALANCE_MODAL } from 'context/cards/types';
// Assets
import { ReactComponent as DisallowedNewCards } from 'assets/createCards/DisallowedNewCards.svg';
import './NoBalanceDialog.css';

const NoBalanceDiaglog = () => {
    const { dispatch, isUnallocatadBalanceModalOpen } = useContext(CardContext);

    return (
        <Dialog className="no-balance-modal" open={isUnallocatadBalanceModalOpen} fullWidth maxWidth="sm">
            <Box display="flex" flexDirection="column" alignItems="center" padding="5rem 0rem">
                <Box className="icon-unallocated">
                    <DisallowedNewCards aria-hidden />
                </Box>
                <Box marginBottom="2rem">
                    <Typography component="h3" className="title">
                        You don't have balance to create a card.
                    </Typography>
                    <Typography className="text" textAlign="center">
                        Please cancel a card or reduce any card limit to create a new card.
                    </Typography>
                </Box>
                <Button onClick={() => dispatch({ type: CLOSE_NO_BALANCE_MODAL })} variant="contained">
                    OK
                </Button>
            </Box>
        </Dialog>
    );
};

export default NoBalanceDiaglog;
